module.exports = __webpack_public_path__ + "static/media/logo_vibbra_inverse.b294fd49.svg";